if (!customElements.get('split-slider')) {
  class SplitSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.button = this.querySelector('[js-dynamic-button]');
      this.buttonDefaultHref = this.button?.getAttribute('href');
      this.swiperElement = this.querySelector('.swiper');

      const slides = this.querySelectorAll('.swiper-slide');
      const paginationImages = Array.from(slides).map((slide) =>
        slide.getAttribute('js-pagination-image-url'),
      );
      const urls = Array.from(slides).map((slide) =>
        slide.getAttribute('js-button-url'),
      );

      this.slider = new Swiper(this.swiperElement, {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
          renderBullet: function (index, className) {
            const paginationImage = paginationImages[index];

            if (!paginationImage) {
              return `<span class="${className}"></span>`;
            }

            return `<span class="${className}">
              <img src="${paginationImage}" alt="Slide ${index + 1}" width="auto" height="auto" loading="lazy">
            </span>`;
          },
        },
        on: {
          slideChange: (swiper) => {
            if (!this.button) return;

            this.button.setAttribute(
              'href',
              urls[swiper.realIndex] || this.buttonDefaultHref,
            );
          },
        },
      });
    }

    destroySlider() {
      this.slider.destroy();
    }
  }

  customElements.define('split-slider', SplitSlider);
}